import { Box } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import TableInfiniteScrolling from "components/common/TableInfiniteScrolling";
import { dataTableTest } from "components/common/TableInfiniteScrolling/data";
import React, { useEffect, useState } from "react";

type Person = {
  firstName: string;
  lastName: string;
  age: number;
  visits: number;
  status: string;
  progress: number;
};

const columnPinning = {
  left: ["select", "firstName", "lastName"],
  right: ["createdAt"],
};

const ViewTable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      setData(dataTableTest);
    }, 200);
  }, []);

  const columns = React.useMemo<ColumnDef<Person>[]>(
    () => [
      {
        id: "id",
        accessorKey: "id",
        header: "ID",
        minSize: 300,
        footer: (props) => props.column.id,
        pinPosition: "left",
      },
      {
        id: "firstName",
        accessorKey: "firstName",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        minSize: 300,
        pinPosition: "left",
      },
      {
        id: "lastName",
        accessorKey: "lastName",
        cell: (info) => info.getValue(),
        header: () => <span>Last Name</span>,
        footer: (props) => props.column.id,
        minSize: 300,
        enablePinning: true,
      },
      {
        accessorKey: "age",
        header: () => "Age",
        footer: (props) => props.column.id,
        minSize: 300,
      },
      {
        accessorKey: "visits",
        header: () => <span>Visits</span>,
        footer: (props) => props.column.id,
        minSize: 300,
      },
      {
        accessorKey: "status",
        header: "Status",
        footer: (props) => props.column.id,
        minSize: 300,
      },
      {
        accessorKey: "progress",
        header: "Profile Progress",
        footer: (props) => props.column.id,
        minSize: 300,
      },
      {
        accessorKey: "createdAt",
        header: "Created At",
        cell: (info) => info.getValue<Date>().toLocaleString(),
        footer: (props) => props.column.id,
        minSize: 300,
      },
    ],
    []
  );
  const handleFetchMore = () => {
    setData([...data, ...dataTableTest]);
  };
  const handleSelection = (item) => {};
  return (
    <Box height={600}>
      <TableInfiniteScrolling
        fetchMore={handleFetchMore}
        columns={columns}
        dataTable={data}
        rowSelected={handleSelection}
        onClickRow={(row) => {}}
        columnPinning={columnPinning}
      />
    </Box>
  );
};

export default ViewTable;
